require.register("blocks/example-custom-block/example-custom-block-view", function(exports, require, module){
  var BlockView = require('views/block/base-block-view');

var exampleCustomBlockView = BlockView.extend({
  load: function () {

  }
});

module.exports = exampleCustomBlockView;

  
});

